import React from "react";
import { Skeleton } from "@mui/material";

const LiveChatUserSkeleton = () => {
  return (
    <div className="tw-w-full tw-bg-[#FFFFFF] tw-border tw-border-[#E9EAEB] tw-rounded-lg">
      {/* Header Skeleton */}
      <div className="tw-border-b tw-border-[#CBD5E1]">
        <div className="tw-p-4 tw-mx-4 tw-flex tw-items-start tw-justify-between">
          <div className="tw-flex tw-items-center tw-space-x-3">
            {/* Avatar with Online Status Skeleton */}
            <div className="tw-relative">
              <Skeleton
                variant="circular"
                width={40}
                height={40}
                className="tw-bg-gray-200"
              />
              <span className="tw-absolute -tw-top-[2px] -tw-right-[4px] tw-h-[6px] tw-w-[6px] tw-p-[6px] tw-rounded-full tw-bg-gray-200 tw-border-2 tw-border-[#FFFFFF]"></span>
            </div>
            {/* User Name Skeleton */}
            <Skeleton
              variant="text"
              width={120}
              height={24}
              className="tw-bg-gray-200"
            />
          </div>
          <div className="tw-flex tw-items-center tw-gap-4">
            {/* Tier Label Skeleton */}
            <Skeleton
              variant="text"
              width={30}
              height={24}
              className="tw-bg-gray-200"
            />
            {/* iBanq Button Skeleton */}
            <Skeleton
              variant="rectangular"
              width={100}
              height={48}
              className="tw-rounded-lg tw-bg-gray-200"
            />
          </div>
        </div>

        {/* Tabs Skeleton */}
        <div>
          <div className="tw-flex tw-gap-10 tw-border-b tw-px-8">
            {["Chat", "Financial Document", "Legal Document"].map((tab) => (
              <Skeleton
                key={tab}
                variant="text"
                width={tab === "Chat" ? 40 : 140}
                height={40}
                className="tw-bg-gray-200"
              />
            ))}
          </div>
        </div>
      </div>

      {/* Messages Area Skeleton */}
      <div className="tw-px-8 tw-py-4 tw-space-y-6  tw-h-[calc(100vh-375px)] ">
        {[1, 2, 3].map((index) => (
          <div
            key={index}
            className={`tw-space-y-2 ${
              index % 2 === 0 ? "tw-flex tw-items-end tw-flex-col" : ""
            }`}
          >
            {/* Message Header */}
            <div className="tw-flex tw-items-center tw-space-x-2">
              {index % 2 !== 0 && (
                <>
                  <Skeleton
                    variant="circular"
                    width={32}
                    height={32}
                    className="tw-bg-gray-200"
                  />
                  <Skeleton
                    variant="text"
                    width={100}
                    height={24}
                    className="tw-bg-gray-200"
                  />
                </>
              )}
              <Skeleton
                variant="text"
                width={80}
                height={20}
                className="tw-bg-gray-200"
              />
            </div>

            {/* Message Content */}
            <div
              className={`${
                index % 2 === 0 ? "" : "tw-ml-10"
              } tw-max-w-[558px]`}
            >
              <Skeleton
                variant="rectangular"
                width="100%"
                height={80}
                className="tw-rounded-lg tw-bg-gray-200"
              />
            </div>

            {/* Message Footer */}
            <div
              className={`${
                index % 2 === 0 ? "" : "tw-ml-10"
              } tw-flex tw-items-center tw-gap-3`}
            >
              <Skeleton
                variant="text"
                width={60}
                height={20}
                className="tw-bg-gray-200"
              />
              <Skeleton
                variant="text"
                width={60}
                height={20}
                className="tw-bg-gray-200"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Input Area Skeleton */}
      <div className="tw-px-8 tw-py-4">
        <div className="tw-relative tw-flex tw-items-center">
          <Skeleton
            variant="rectangular"
            width="100%"
            height={48}
            className="tw-rounded-lg tw-bg-gray-200"
          />
          <div className="tw-absolute tw-right-2">
            <Skeleton
              variant="circular"
              width={32}
              height={32}
              className="tw-bg-gray-200"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveChatUserSkeleton;
